<template>
  <div class="tolerance-page">
    <div class="container">
      <!-- 标题固定在最上方 -->
      <h1 class="page-title">Compression Molding Tolerances</h1>

      <!-- 表格固定在标题下方，居中显示 -->
      <div class="tolerance-table-wrapper">
        <table class="tolerance-table">
          <tbody>
            <tr>
              <th></th>
              <th>Tolerance</th>
            </tr>
           
            <tr>
              <td>Linear Dimension</td>
              <td>	
+/- 0.01 mm<br>+/- 0.004 inch</td>
           </tr>
            <tr>
              <td>Hole Diameters</td>
              <td>+/- 0.005 mm<br>+/- 0.002 inch</td>
           </tr>
      
          </tbody>
        </table>
      </div>
      <!-- 按钮固定在最下方 -->
      <div class="button-wrapper">
        <button class="getQuote-btn" @click="$router.push('/quote')">Get Instant Quote</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Compression_Capabilities'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}
.tolerance-page {
  padding: 40px 20px;
  background-color: #ffffff;
 
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
}

/* 标题样式 */
.page-title {
  font-size: 36px;
  color: #333333;
  margin: 0 0 30px;
  font-weight: 600;
}

.tolerance-table-wrapper {
  width: 100%;
  margin-bottom: 30px;
  overflow-x: auto;
}

.tolerance-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  table-layout: fixed;
}

.tolerance-table thead tr {
  background-color: #f0f4f5;
}



.tolerance-table th,
.tolerance-table td {
  padding: 20px 15px;
  text-align: center;
  border: 1px solid #e5e7eb;
  color: #333333;
  font-size: 16px;
  line-height: 1.5;
}


.tolerance-table th {
  font-weight: 600;
}

.tolerance-table td:first-child {
  font-weight: 500;
}
.tolerance-table th{
  background-color: #f0f4f5;
  font-weight: 700;
}

/* 第一列 */
.tolerance-table td:first-child {
  width: 20%;
}

/* 第二列 */
.tolerance-table td:last-child {
  width: 80%;
}

/* 说明文字 */
.disclaimer-text {
  font-size: 16px;
  color: #666666;
  line-height: 1.6;
  margin: 0 auto 35px;
  max-width: 800px;
}

/* 按钮容器 */
.button-wrapper {
  display: flex;
  justify-content: center;
}

.getQuote-btn {
  background-color: #16bc9c;
  color: #ffffff;
  border: none;
  padding: 14px 30px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.download-btn:hover {
  background-color: #13a88b;
}

/* 响应式适配（仅缩小字体和内边距，不改变顺序） */
@media (max-width: 768px) {
  .page-title {
    font-size: 28px;
  }

  .tolerance-table th,
  .tolerance-table td {
    padding: 15px 10px;
    font-size: 14px;
  }

  .disclaimer-text {
    font-size: 14px;
  }
}
</style>